module.exports = __webpack_public_path__ + "fonts/4520188144a17fb24a6af28a70dae0ce.732389de.ttf";